export const emulatorVolumeLocalStorageKey = 'currentEmulatorVolume';
export const emulatorKeyBindingsLocalStorageKey = 'currentEmulatorKeyBindings';
export const emulatorGameNameLocalStorageKey = 'currentGameName';
export const emulatorFFMultiplierLocalStorageKey = 'currentFastForward';
export const emulatorSettingsLocalStorageKey = 'emulatorSettings';
export const emulatorAutoSaveUnloadLocalStorageKey = 'unloadedAutoSaveState';
